"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = void 0;
var utils_1 = require("./utils");
function validate(_a, copyMap) {
    var accountNumber = _a.accountNumber, amountBase = _a.amount, bankAuthorised = _a.bankAuthorised, ddGuaranteeAccepted = _a.ddGuaranteeAccepted, givenName = _a.givenName, familyName = _a.familyName, sortCodeBase = _a.sortCode;
    var errors = [];
    var amount = (0, utils_1.stripSpaces)(amountBase);
    var sortCode = (0, utils_1.stripSpacesAndDashes)(sortCodeBase);
    if (amount === '') {
        errors.push({
            id: 'amount',
            message: copyMap.noAmount,
        });
    }
    else if (!/^\d+(\.\d\d)?$/.test(amount)) {
        errors.push({
            id: 'amount',
            message: copyMap.invalidAmount,
        });
    }
    else {
        var _b = __read("".concat(amount, ".00").split('.'), 2), pounds = _b[0], pence = _b[1];
        var amountInPence = Number(pounds) * 100 + Number(pence);
        if (amountInPence < 100 || amountInPence > 200000) {
            errors.push({
                id: 'amount',
                message: copyMap.rangeAmount,
            });
        }
    }
    if (givenName === '') {
        errors.push({
            id: 'givenName',
            message: copyMap.givenName,
        });
    }
    if (familyName === '') {
        errors.push({
            id: 'familyName',
            message: copyMap.familyName,
        });
    }
    if (accountNumber === '') {
        errors.push({
            id: 'accountNumber',
            message: copyMap.noAccountNumber,
        });
    }
    else if (/[^\d]/.test(accountNumber)) {
        errors.push({
            id: 'accountNumber',
            message: copyMap.invalidAccountNumber,
        });
    }
    else if (accountNumber.length !== 8) {
        errors.push({
            id: 'accountNumber',
            message: copyMap.accountNumberLength,
        });
    }
    if (sortCode === '') {
        errors.push({
            id: 'sortCode',
            message: copyMap.noSortCode,
        });
    }
    else if (/[^\d]/.test(sortCode)) {
        errors.push({
            id: 'sortCode',
            message: copyMap.invalidSortCode,
        });
    }
    else if (sortCode.length !== 6) {
        errors.push({
            id: 'sortCode',
            message: copyMap.sortCodeLength,
        });
    }
    if (!bankAuthorised) {
        errors.push({
            id: 'bankAuthorised',
            message: copyMap.bankAuthorised,
        });
    }
    if (!ddGuaranteeAccepted) {
        errors.push({
            id: 'ddGuaranteeAccepted',
            message: copyMap.ddGuarantee,
        });
    }
    return errors;
}
exports.validate = validate;
